import { asDefined, panic, RuntimeNotifier } from "@opendaw/lib-std";
import { ExternalLib } from "../ExternalLib";
import { CATEGORIES } from "./PresetMeta";
export var PresetBundle;
(function (PresetBundle) {
    const VERSION = "1";
    const META_PATH = "meta.json";
    const PRESET_PATH = "preset.odp";
    PresetBundle.encode = async (meta, data) => {
        const { status, value: JSZip, error } = await ExternalLib.JSZip();
        if (status === "rejected") {
            await RuntimeNotifier.info({ headline: "Error", message: `Could not load JSZip: ${String(error)}` });
            return Promise.reject(error);
        }
        const zip = new JSZip();
        zip.file("version", VERSION);
        zip.file(META_PATH, JSON.stringify(meta, null, 2));
        zip.file(PRESET_PATH, data, { binary: true });
        const blob = await zip.generateAsync({ type: "blob", compression: "DEFLATE", compressionOptions: { level: 6 } });
        return blob.arrayBuffer();
    };
    PresetBundle.decode = async (arrayBuffer) => {
        const { status, value: JSZip, error } = await ExternalLib.JSZip();
        if (status === "rejected") {
            await RuntimeNotifier.info({ headline: "Error", message: `Could not load JSZip: ${String(error)}` });
            return Promise.reject(error);
        }
        const zip = await JSZip.loadAsync(arrayBuffer);
        const version = await asDefined(zip.file("version"), "Not a preset bundle").async("text");
        if (version !== VERSION) {
            return panic("Unknown bundle version");
        }
        const meta = JSON.parse(await asDefined(zip.file(META_PATH), "Missing meta.json").async("text"));
        if (!CATEGORIES.includes(meta.category)) {
            return panic("Unknown preset category");
        }
        const data = await asDefined(zip.file(PRESET_PATH), "Missing preset.odp").async("arraybuffer");
        return { meta, data };
    };
})(PresetBundle || (PresetBundle = {}));
